export default {
	translation: {
		ipPhone: 'IP-телефон',
		addRecord: 'Эбии суруй',
		editRecord: 'Суруллубуту көннөр',
		noData: 'Туох да көстүбэтэ',
		all: 'Барыта',
		fio: 'ААА',
		from: 'кимтэн',
		find: 'Бул',
		publishAt: 'Киэҥ билиигэ тахсыбыт күнэ-дьыла',
		publish: 'Киэҥ билиигэ таһаарылынна ',
		note: 'Хос быһаарыы',
		archive: 'Архыыпка',
		pressCenter: 'Пресс-киин',
		actual: 'Тирээн турар суолталаах',
		acceptAt: 'Ылыллыбыт күнэ',
		number: 'Нүөмэрэ',
		datePickerPlaceholder: 'КК.ЫЫ.СС',
		byCounty: 'Оройуоннарынан',
		showNote: 'Хос быһаарыыны көрдөр',
		hideNote: 'Хос быһаарыыны сап',
		showNoteLigament: 'Хос быһаарыыны/сибээскэни көрдөр',
		hideNoteLigament: 'Хос быһаарыыны/сибээскэни сап',
		orderBy: 'Суортарынан араар',
		layers: 'Араҥалар',
		area: 'Иэн',
		flag: 'Былаах',
		close: 'Сабан кэбис',
		portal: 'Портаал',
		portalMap: 'Портаал каартата',
		enter: 'Киир ',
		reset: 'Уһул',
		resetAll: 'Барытын уһул',
		showMore: 'Өссө көрдөр',
		adminCenter: 'Административнай киин',
		oktmo: 'ОКТМО',
		badVision: 'Мөлтөхтүк көрөөччүлэргэ версия',
		banners: 'Баннердар',
		author: 'Ааптар',
		code: 'Куод',
		default: 'Эрдэ олохтоммут бэрээдэгинэн',
		upload: 'Хачайдаан ыл',
		material: 'Матырыйаал',
		selectImage: 'Ойууну/уруһуйу тал',
		addImage: 'Ойууну/уруһуйу эбэн биэр',
		add: 'Эбэн биэр',
		save: 'Харайыы',
		saveAndExit: 'Харайыы уонна тахсыы',
		rating: {
			one: 'сыанабыл',
			two: 'сыанабыллар',
			five: 'сыанабылларын',
		},
		date1: 'Күнүттэн ыла',
		date2: 'Күнүгэр диэри',
		info: 'Иһитиннэрии',
		putRating: 'Баһаалыста, бэйэҥ сыанаҕын туруор',
		view: {
			title: 'Көрүү',
			plural: 'Көрүүлэр',
		},
		county: {
			title: 'Оройуон ',
			plural: 'Оройуоннар ',
			select: 'Оройуону тал',
			administrativeCenter: 'Административнай киин',
			admCenter: 'Адм. киин',
			square: 'Иэн',
			includes: 'Киллэрэр',
			population: 'Нэһилиэнньэ ',
			sitesOfThisArea: 'Бу оройуон саайтара',
		},
		searchPage: {
			article: 'Сонуннар',
			event: 'Буолбут түгэннэр',
			vacancy: 'Үлэ аһаҕас миэстэтэ',
			questionAnswer: 'Ыйытыы-харда',
			linksFeedLink: 'Туһалаах матырыйаал',
			album: 'Медиа',
			document: 'Докумуоннар ',
			searchResult: 'Көрдөөһүн түмүгэ',
			portalSearch: 'Порталга көрдөөһүн',
			goToSection: 'Түһүмэххэ көс',
			chapter: 'түһүмэх',
			allResults: 'Түһүмэххэ булуллубут бары түмүктэр',
		},
		password: {
			title: 'Пароль',
		},
		record: {
			saved: 'Суруллубут киирдэ',
			deleted: 'Суруллубут сотулунна',
		},
		audit: {
			title: 'Сурунаалга киллэрии',
			model: 'Мадьыал',
			action: 'Дьайыы',
			create: 'Оҥоруу/тэрийии',
			delete: 'Суох оҥоруу/сотторуу',
			update: 'Саҥардыы',
			select: 'Суруллубуту тал',
			data: 'Суруллубут чахчылар',
			owner: 'Туһанааччы',
			hidden: '*кистэммит*',
			objectId: 'Эбийиэк ID',
		},
		user: {
			title: 'Туһанааччы',
			plural: 'Туһанааччылар',
			blocked: 'Хааччахтаммыт',
			position: 'Соло',
			lastAuthDate: 'Бүтэһигин киирэ сылдьыбыт күнэ-дьыла',
			create: 'Саҥа туһанааччы',
			profile: 'Сирэйэ',
			email: 'E-mail',
			emailVerified: 'Бигэргэммит e-mail',
			name: 'Логин',
			firstName: 'Аата',
			lastName: 'Араспаанньата',
			middleName: 'Аҕатын аата',
			leftComment: 'быһаарыы хаалларбыт',
			createdTask: 'сорук туруорбут',
			telegram: 'Telegram ID',
			username: 'Логин',
			password: 'Пароль',
			avatar: 'Аватар',
			fullName: 'АААА',
			organizationName: 'Тэрилтэ',
			searchFioPositionOrganization: 'АААА, солотунан, тэрилтэнэн көрдөөһүн',
			canAccess: 'Туһанааччы туһанар кыахтанар',
			allData: 'бары чахчылар',
			limitRegion: 'эрэгийиэнинэн чахчылар:',
			limitCounty: 'оройуонунан чахчылар:',
			languages: 'Тыллар эрэдээктэрдэрэ',
			limitCity: 'куоратынан чахчылар:',
			countyName: 'Оройуон',
			cityName: 'Куорат/нэһ. пуун',
			error: {
				email: {
					custom: {
						email: 'Сыыһа e-mail',
					},
					uniqueness: 'Маннык E-mail номнуо баар',
					verifySent: 'Бигэргэтэргэ е-mail сурук ыытылынна',
				},
			},
		},
		role: {
			title: 'Оруол',
			plural: 'Оруоллар',
			create: 'Саҥа оруол',
			created: 'тэриллибит/оҥоһуллубут',
			modified: 'уларытыллыбыт',
			name: 'Куод',
			description: 'Аата',
			isSaving: 'Бырааптара оннунан хаалар...',
		},
		footer: {
			siteMapTitle: 'Саайт түһүмэхтэрэ',
			portalsTitle: 'Портаал',
		},
		siteType: {
			plural: 'Саайт көрүҥнэрэ',
			title: 'Саайт көрүҥэ',
			parent: 'Төрүт көрүҥ',
		},
		copyright: {
			sendAppeal: 'Этиитэ (туруорсуута) киллэр',
			login: 'Киир',
			policy: 'Кистэлэҥҥэ тутуу бэлиитикэтэ',
			userAgreement: 'Туһанааччыны кытта түһэрсиллэр сөбүлэһии',
			allRightsReserved: '© Бары быраап көмүскэллэннэ',
		},
		openData: {
			title: 'Аһаҕас чахчылар',
			dataLibrary: 'Чахчылар бибилэтиэкэлэрэ',
			dataSetsFound: 'Чахчылар холбоһуктара булулунна',
			openDataSearch: 'Аһаҕас чахчыларынан көрдөөһүн',
			responsiblePerson: 'Эппиэттээх сирэй',
			phoneResponsiblePerson: 'Эппиэттээх сирэй төлөпүөнэ',
			emailResponsiblePerson: 'Эппиэттээх сирэй е-mail',
			agency: 'Уорган',
			identificationNumber: 'Идентификациялыыр нүөмэр',
			publishAt: 'Киэҥ билиигэ таһаарылынна',
			updatedAt: 'Бүтэһик уларытыы',
			versionGuidelines: 'Методическай сүбэ көрүҥэ',
			chapter: 'Салаа ',
			actualDataAt: 'Уһулуччу суолталаммыт күнэ-дьыла',
			dataSet: 'Чахчылар холбоһуктара',
			passport: 'Пааспар',
			structure: 'Тутул',
			table: 'Табылыысса',
			generalAssessment: 'Уопсай сыанабыл',
			pleaseYourRating: 'Баһаалыста, бэйэҥ сыанаҕын туруор',
			byUpdateDateAscending: 'Саҥардыллыбыт күнүнэн (улаатан иһиитинэн)',
			byUpdateDateDescending: 'Саҥардыллыбыт күнүнэн (кыччаан иһиитинэн)',
			text: 'Чахчылар нобуордарын ойуулааһын',
			format: 'Аһаҕас чахчылары нобуордааһын кээмэйэ',
			descriptionStructure: 'Аһаҕас чахчылары нобуордааһын тутулун ойуулааһын',
			uriSelect: 'Нобуорга гиперсигэ (URL)',
			uriOpenData: 'Аһаҕас чахчылар версияларын гиперсигэтэ (URL)',
			uriStructure: 'Аһаҕас чахчылар тутулларын версияларын гиперсигэтэ (URL)',
			name: 'Аата',
		},
		aboutRepublic: {
			title: 'Өрөспүүбүлүкэ туһунан ',
			material: 'Матырыйааллар',
			searchMaterial: 'Матырыйаалларынан көрдөөһүн',
			infoAboutRepublic: 'Өрөспүүбүлүкэ туһунан иһитиннэрии',
			geography: 'География',
			historyTime: 'Устуоруйа уонна кэм',
			personality: 'Тустаах дьон олоҕун-үлэтин туһунан иһитиннэрии',
			cultureArt: 'Култуура уонна ускуустуба',
			religion: 'Итэҕэл',
			humanSociety: 'Киһи уонна уопсастыба ',
			scienceNature: 'Билим уонна Айылҕа үөрэҕэ',
			technics: 'Тиэхиньикэ',
			sport: 'Успуорт',
			economy: 'Экэниэмикэ',
			education: 'Үөрэх',
			newOnMaterials: 'Матырыйаалларга баар саҥа киириилэр',
			generalInformation: 'Уопсай сибидиэнньэ',
		},
		aboutrepubliccategory: {
			title: 'Категорията',
		},
		republicMaterial: {
			title: 'Өрөспүүбүлүкэ матырыйаала',
			plural: 'Өрөспүүбүлүкэ матырыйааллара',
		},
		citizensAppeals: {
			title: 'Гражданнар туруорсуулара',
			appeal: 'Туруорсуу',
			firstName: 'Араспаанньата',
			name: 'Аата',
			middleName: 'Аҕатын аата',
			withoutMiddleName: 'Аҕата биллибэт',
			coAuthorWithoutMiddleName: 'Хос ааптар аҕатын аата биллибэт',
			theme: 'Тиэмэ',
			recipient: 'Аадырыстаах',
			result: 'Түмүк',
			phone: 'Билсэр төлөпүөн',
			email: 'Электроннай почта аадырыһа',
			enterEmail: 'Электроннай почта аадырыһын киллэр',
			organization: 'Тэрилтэ аата',
			addCoAuthor: 'Хос ааптары эп',
			subjectAppeals: 'Туруорсуу тиэмэтэ',
			statusAppeals: 'Туруорсуу туруга',
			textAppeals: 'Туруорсуу тиэкиһэ',
			legalEntity: 'Юридическай сирэй ',
			supported: 'Өйөннө',
			partialSupported: 'Сорҕото өйөннө (өскөтүн туруорсууга хас да ыйытыы киирбит буоллаҕына)',
			explained: 'Быһаарыы бэрилиннэ',
			hasTheDeadline: 'Туруорсууҥ көрүллүбүт түмүгүнэн ылыллыбыт быһаарыыны  толоруу болдьоҕо быһаарыллыбыт дуо?',
			specifyDeadline: 'Туруорсууҥ көрүллүбүт түмүгүнэн ылыллыбыт быһаарыыны толоруу болдьоҕун ый (баар буоллаҕына)',
			evaluateTheWork: 'Туруорсууҥ көрүллүүтүнэн судаарыстыбаннай былаас толорор уорганын (олохтоох салайыныы уорганын) үлэтин сыаналаа',
			naturalPerson: 'Физическэй сирэй',
			appealSent: 'Туруорсуу ыытылынна',
			authorAppeal: 'Туруорсуу ааптара',
			buttonForCollectiveAppeals: 'Кэлэктиибинэн туруорсууга аналлаах кунуопка',
			postalAddress: 'Почтатын аадырыһа',
			thankYouVeryMuch: 'Улахан махтал!',
			yourLetterSent: '"Суругуҥ ыытылынна уонна киирбит түгэниттэн үс күн иһигэр булгуччу регистрацияланыахтаах"',
			answerTheQuestions: 'Туруорсууҥ көрүллүбүт түмүгүнэн  ыйытыыларга хардар',
			answerTheQuestionsAdmin: 'Туруорсууҥ көрүллүбүт түмүгүнэн ыйытыыларга хардар',
			whatDecisionWasMade: 'Туруорсууҥ көрүллүбүт түмүгүнэн ханнык быһаарыы ылылынна?',
			fileSizeNotExceed10Mb: 'Файл кээмэйэ 10Мб куоһарыа суохтаах',
			agreementWithTheRules: 'Туруорсууну киллэрии быраабылаларын кытта сөбүлэһэбин',
			formEvaluationOfResults: 'Туруорсуулары көрүү түмүгүн сыаналааһын киэбэ',
			coAuthorAppeal: ' Туруорсуу хос ааптара',
			removeCoAuthor: 'Хос ааптары сотон кэбис',
			fillFormCitizensElectronicAppeal: 'Кыһалҕаҕын быһаарарга анаан гражданнар туруорсууларын электроннай көрүҥүн толор',
			surnameFirstNamePatronymicTheOfficial: 'Сололоох сирэй Араспаанньата, Аата, Аҕатын Аата',
			selectFromTheList: 'Кэрискэттэн тал',
			inorderProtectAgainstThePossibleIntroductionOfVirusPrograms:
				'Вирустаах бырагыраамалары киллэрииттэн көмүскэнэр инниттэн манна тиэкиһи куопуйалыыр уонна көһөрөр бобуллар',
			consentToDataProcessing:
				'Мин бэйэм туспунан чахчылары ситэри оҥорорго сөбүлэҥмин бигэргэтэбин. Мин туспунан чахчылар хайдах хараллалларын уонна туттуллалларын туһунан сиһилии',
			personalInformationIsStoredAndProcessed:
				'Тус чахчылар тустарынан тус чахчыларга хабааннаах иһитиннэрии  Россия сокуоннарын ирдэбиллэригэр сөп түбэһиннэрэн хараллар уонна ситэри оҥоһуллар. Туруорсууну көрөргө туруорсууга баар сибидиэнньэлэри, ону тэҥэ гражданин тус олоҕун таарыйар сибидиэнньэлэри кини көҥүлэ суох тарҕатыы бобуллар.',
			isNotDisclosureOfInformation:
				'Туруорсууга баар боппуруостары быһаарар боломуочуйалаах судаарыстыбаннай уоргаҥҥа, олохтоох салайыныы уорганыгар эбэтэр сололоох сирэйгэ суругунан туруорсууну ыытыы туруорсууга баар сибидинньэлэри тарҕатыынан буолбат.',
			totalApplicationsSubmitted: 'СӨ дьиҥ таһымнаах иһитиннэриитин портаалын көмөтүнэн бэриллибит туруорсуу барыта',
			responsesToRequests: 'Туруорсууларга хардалар',
			hasTheDecisionMade: 'Туруорсууҥ көрүллүбүт түмүгүнэн ылыллыбыт быһаарыы туолла дуо?',
			measuresTaken: 'Дьаһал ылылынна',
			measuresBeingTaken: 'Дьаһаллар ылыллаллар (болдьох уһатылынна)',
			registeredAtRK: 'РК регистрацияламмыт күнэ-дьыла',
			numberRKinESED: 'ЕСЭД-кэ РК №',
			dateOriginRKinESED: 'ЕСЭД-кэ РК барбыт күнэ',
			outgoingNumberRKinESED: 'ЕСЭД-кэ РК барбыт №',
			typeResponse: 'Харда көрүҥэ',
			electronically: 'Электроннай көрүҥүнэн',
			inWriting: 'Суругунан',
			enterMessageOnTheQuestionOfInterest: 'Интэриэһиргиир боппуруоскунан иһитиннэриигин киллэр',
			enterYorFamily: 'Араспаанньаҕын киллэр',
			socialStatus: 'Социальнай балаһыанньа ',
			executor: 'Толорооччу',
			exportInExcel: 'Ексельгэ көһөр',
			summaryReport: 'Түмүллүбүт отчуот',
			sendToESED: 'ЕСЭДкэ ыыт',
		},
		pageDescription: {
			plural: 'Сирэйдэр ис хоһоонноро',
			title: 'Сирэй ис хоһооно',
		},
		managements: {
			pageTitle: 'Салалта',
			tabGroup: 'Салайааччылар бөлөхтөрө',
			tabList: 'Салалта',
			photo: 'Хаартыска',
			plural: 'Салалта',
			title: 'Салайааччы',
			fio: 'АААА',
			compositionGovernment: 'Бырабыыталыстыба састааба',
			dateOfBirth: 'Төрөөбүт күн',
			position: 'Соло',
			education: 'Үөрэх',
			biography: 'Олоҕун кэпсээнэ',
			phone: 'Приемнай төлөпүөнэ',
			supervisedDirections: 'Сүрүннэнэр хайысхалар',
			legalActs: 'Быраап аактара',
			otherInformation: 'Атын сибидиэнньэлэр',
			preRegistrationPhone: 'Эрдэттэн суруйтарыы IP төлөпүөнүнэн',
			email: 'Дьиҥ таһымнаах суруктарга e-mail',
			laborActivity: 'Үлэ-хамнас',
			descriptionOfActivity: 'Үлэни-хамнаһы кэпсээ',
			departmentalAwards: 'Биэдэмистибэ наҕараадалара уонна үтүөлээх ааттар',
			contacts: 'Контактар',
			address: 'Почтаҕа ыйыллар аадырыс',
			schedule: 'Приемнуур график',
			assistant: 'Көмөлөһөөччү',
			notFound: 'Салайааччы булуллубата',
		},
		month: {
			title: 'Ый',
			january: 'Тохсунньу',
			february: 'Олунньу',
			march: 'Кулун тутар',
			april: 'Муус устар',
			may: 'Ыам ыйа',
			june: 'Бэс ыйа',
			july: 'От ыйа',
			august: 'Атырдьах ыйа',
			september: 'Балаҕан ыйа',
			october: 'Алтынньы',
			november: 'Сэтинньи',
			december: 'Ахсынньы',
		},
		supportMeasure: {
			title: 'Өйөбүл дьаһаллара',
			plural: 'Өйөбүл дьаһаллара',
			all: 'Барыта',
			searchBySupportMeasure: 'Өйөбүл дьаһалларынан көрдөөһүн',
			descriptionMeasure: 'Дьаһал ис хоһооно',
			additionalInfo: 'Эбии иһитиннэрии',
			evaluateMeasure: 'Дьаһалы сыаналаа',
			usefulInfo: 'Бу иһитиннэрии эйиэхэ туһалаата дуо?',
			interestingAndUseful: 'Интэриэһинэй уонна туһалаах',
			anotherColumns: 'Атын ыстатыйалар',
			goToOtherMeasures: 'Атын дьаһалларга көһүү',
			formsArrayFirst: 'өйөбүл дьаһала',
			formsArraySecond: 'өйөбүл дьаһаллара',
			formsArrayThird: 'өйөбүл дьаһалларын',
		},
		siteManagment: {
			plural: 'Саайты салайыы',
			title: 'Саайты салайыы',
		},
		event: {
			plural: 'Буолбут түгэн халандаара',
			title: 'Буолбут түгэн халандаара',
		},
		eventtype: {
			title: 'Буолбут түгэн көрүҥэ',
		},
		poster: {
			title: 'Афиша',
		},
		events: {
			announcement: 'Анонсалар',
			calendar: 'Халандаар',
			list: 'Кэрискэ/испииһэк',
			events: 'Буолбут түгэннэр',
			holidays: 'Бырааһынньыктар',
			noEvents: 'Буолбут түгэн булуллубата',
			noHolidayEvents: 'Бырааһынньык булуллубата',
			formsArrayFirst: 'буолбут түгэн',
			formsArraySecond: 'буолбут түгэннэр',
			formsArrayThird: 'буолбут түгэннэри',
			organizer: 'Тэрийээччи',
			executionType: 'Ыытыы көрүҥэ',
		},
		eventstatus: {
			title: 'Статус',
		},
		media: {
			image: 'Ойуу/уруһуй',
			video: 'Видео',
			audio: 'Аудио',
			plural: 'Медианы харайар сир',
			searchByMedia: 'Медианы харайар сиргэ көрдөөһүн',
			formsArrayFirst: 'медиаматырыйаал',
			formsArraySecond: 'медиаматырыйаалы',
			formsArrayThird: 'медиаматырыйааллары',
			nothingFound: 'Хомойуох иһин, эн ыйытыккынан туох да суох',
		},
		questionAnswer: {
			title: 'Ыйытыы-хоруй',
			plural: 'Ыйытыы-хоруй',
			source: 'Төрүт матырыйаал',
			noDeleteSubCategory: 'Бу хос категория ыйытыы-хоруй суруйууга ыйыллыбытын быһыытынан сотторор сатаммат',
		},
		allSites: {
			lineTitle: 'Бары саайтар',
			plural: 'Бары саайтар',
			short: 'Бары',
			popularTitle: 'Портаал киэҥник биллэр саайтара',
			goToDepartment: 'Биэдэмистибэҕэ көһүү',
			allPortalSites: 'Портаал бары саайтара ',
			popularSitesLineTitle: 'Портаал киэҥник биллэр саайтара',
			aboutPart: 'Түһүмэх туһунан',
			aboutPartTitle: 'Бу түһүмэххэ Портаал иһинээҕи саайтарга көһүөххүн сөп',
			aboutPartText:
				'Урукку өттүгэр Портаалынан туһамматах дьоҥҥо бу курдук билиһиннэрэр тиэкиһи суруйуохха сөп. Туһанааччыларга бу курдук: Портаал Sakha.gov.ru Портаал сүрүн саайтыттан уонна Саха Өрөспүүбүлүкэтин дьиҥ таһымнаах портаалыгар саайтаах тэрилтэлэр, сололоох сирэйдэр, юридическай сирэйдэр - субъектар саайтарыттан турар. Субъектар саайтарынан СӨ Ил Дарханын саайта, СӨ Бырабыыталыстыбатын саайта, СӨ Бырабыыталыстыбатын Бэрэссэдээтэлин саайта, СӨ Бырабыыталыстыбатын Бэрэссэдээтэлин солбуйааччыларын саайтара, Аһаҕас бырабыыталыстыба портаала, судаарыстыбаннай былаас толорор уорганнарын саайтара, СӨ судаарыстыбаннай былааһын уорганнарын уонна олохтоох салайыныы уорганнарын саайтара, судаарыстыбаннай былаас уорганарыгар бас бэринэр тэрилтэлэр саайтара, олохтоох салайыныы уорганнарыгар бас бэринэр тэрилтэлэр саайтара буолаллар. Портаал туспа биэдэмистибэлэр хос доменнарыгар уонна судаарыстыбаннай былаас уорганнарыгар уонна олохтоох салайыныы уорганнарыгар бас бэринэр тэрилтэлэр саайтарыгар киириини хааччыйыахтаах.',
			populars: 'Киэҥник биллэр',
		},
		usefulLinks: {
			title: 'Туһалаах ресурсалар',
		},
		superBlock: {
			title: 'Супер блок',
			unit: 'Блок',
			tabTitle: 'Киллэһик аата',
			icon: 'Иконканы тал',
			selectTheList: 'Кэрискэттэн тал',
			selectTheNews: 'Сонун',
			selectTheEvent: 'Бэлиэ түгэн (тэрээһин)',
			selectTheQuestion: 'Ыйытыы-хоруй',
		},
		acl: {
			search: 'Мадьыал аатынан эбэтэр ойуулааһынынан көрдөөһүн',
			title: 'Быраап ',
			plural: 'Бырааптар',
			create: 'Саҥа быраап',
			principalType: 'Субъект көрүҥэ',
			app: 'Сыһыарыы',
			role: 'Оруол',
			user: 'Туһанааччы',
			accessType: 'Дьайыы',
			read: 'Ааҕыы',
			write: 'Суруйуу',
			execute: 'Толоруу',
			all: 'Барыта',
			principalId: 'Субъект',
			model: {
				title: 'Мадьыал',
				user: 'Туһанааччылар',
				project: 'Бырайыактар',
				person: 'Персоналар',
				description: 'Ойуулааһын',
			},
			permission: 'Быраап',
			allow: 'Көҥүллээ',
			deny: 'Бобуу',
			property: 'Бэлиэ',
			allowAll: 'Барытын көҥүллээ',
			list: 'Бырааптар кэрискэлэрэ',
		},
		roleMapping: {
			title: 'Оруол ',
			plural: 'Оруолу анааһын',
			create: 'Оруолу саҥа анааһын',
		},
		news: {
			title: 'Сонуннар',
			last: 'Кэлиҥҥи',
			capital: 'Киин куорат',
			county: 'Оройуоннар',
			republic: 'Өрөспүүбүлүкэ',
			inCountry: 'Дойдуга',
			inWorld: 'Аан дойдуга',
			ulus: 'Улуус',
			rubric: 'Рубрикалар',
			appurtenance: 'Туохха сыһыаннааҕа',
			appurtenances: 'Туохха сыһыаннааҕа',
			importantNews: 'Дьоһун суолталаах сонуннар',
			allImportantNews: 'Өрөспүүбүлүкэ дьоһун суолталаах сонуна барыта',
			showImportantNewsOnPanel: 'Панелга "Дьоһун суолталаах сонуннар" диэни көрдөр',
			showMore: 'Өссө көрдөр',
			newsTop: 'Сүрүн сонуннар',
			newsByTheme: 'Тиэмэнэн сонуннар',
			searchByNews: 'Сонуннарга көрдөөһүн',
			noNewsFound: 'Сонуннар булуллубатылар',
			mainThing: 'Сүрүн',
			signatureAuthorPhoto: 'Хаартыска аннынааҕы сурук эбэтэр ааптара',
			showOnSupportWidget: '"Өйөбүл дьаһаллара" виджекка көрдөр',
			formsArrayFirst: 'матырыйаал',
			formsArraySecond: 'матырыйаала',
			formsArrayThird: 'матырыйааллары',
		},
		vacancy: {
			unifiedDatabaseOfVacancies: 'Аһаҕас турар үлэ миэстэтин биир кэлим баазата',
			title: 'Аһаҕас турар үлэ миэстэтэ',
			searchByParameter: 'Параметрынан көрдөөһүн',
			organizationInitiatorTitle: 'Тэрилтэ, тэрийии /Көҕүлээччи',
			titles: 'Аһаҕас турар үлэ миэстэлэрэ',
			plural: 'Аһаҕас турар үлэ миэстэлэрэ',
			basis: 'Төрүтэ ',
			branch: 'Тэрилтэ салаата',
			contactPerson: 'Ситимниир сирэй',
			linkContactPerson: 'Ситимниир сирэйгэ сигэ',
			linkButton: '"Сэҥээрбиккин биллэр" кунуопкаҕа сигэ',
			education: 'Үөрэх',
			primarySourceSite: 'Төрүт саайт',
			information: 'Иһитиннэрии',
			linkBasis: '"Төрүтэ" диэҥҥэ сигэ',
			respond: 'Сэҥээрбиккин биллэр',
			totalVacancy: 'Аһаҕас турар үлэ миэстэтэ барыта:',
			shortDescription: 'Аһаҕас турар үлэ миэстэтин кылгас ойуулааһын',
			showVacancyOnPanel: 'Панелга "Аһаҕас турар үлэ миэстэтэ" диэни көрдөр',
			workExp: 'Үлэ уопута',
			showAllVacancies: 'Аһаҕас турар үлэ миэстэтин барытын көр',
			lastVacancies: 'Бүтэһик аһаҕас турар үлэ миэстэтэ',
		},
		vacancystatus: {
			title: 'Анал турук',
		},
		searchInput: {
			searchByName: 'Аатынан көрдөөһүн',
			submit: 'Көрдөө',
			advanced: 'Тэнитэн көрдөөһүн',
			fast: 'Түргэн көрдөөһүн',
			placeholder: 'Көрдөөһүн',
			placeholderPhonebook: 'Төлөпүөн ыйынньыгынан көрдөөһүн',
			placeholderDocumentsAcceptBody: 'Докумуонунан, нүөмэринэн уонна ылар уорганынан көрдөөһүн',
			placeholderAllSites: 'Тэрилтэ эбэтэр биэдэмистибэ саайтын көрдөөһүн',
		},
		apartment: 'Кыбартыыра/офис',
		startDate: 'Саҕаланар күнэ-дьыла',
		endDate: 'Бүтэр күнэ-дьыла',
		information: 'Иһитиннэрии',
		settings: 'Настройкалар',
		delete: 'Сотторуллар дуо?',
		day: 'Күн',
		year: 'Сыл',
		tag: {
			title: 'Тег',
			plural: 'Тегтэр',
			all: 'Тег барыта',
		},
		page: {
			plural: 'Сирэйдэр',
			title: 'Сирэй',
		},
		interactiveMap: {
			title: 'Интерактивнай каарта',
			goToSite: 'Саайка көһүү',
			lastNewsCounty: 'Оройуон тиһэх сонуннара',
		},
		analytics: 'Аналитика',
		backToSection: 'Түһүмэххэ төнүн',
		backToMainPage: 'Сүрүн сирэйгэ төнүн',
		category: 'Категория',
		categories: 'Категориялар',
		subCategory: 'Хос категория',
		contacts: 'Контактар',
		cover: 'Тас өттө',
		color: 'Дьүһүнэ',
		colorRGB: 'Дьүһүн',
		colorHEX: 'Дьүһүн (HEX)',
		colorTextRGB: 'Тиэкис дьүһүнэ (RGB)',
		colorTextHEX: 'Тиэкис дьүһүнэ (HEX)',
		downloadFile: 'Файлы хачайдаа',
		download: 'Хачайдаа',
		fileName: 'Файл аата',
		fileSize: 'Файл кээмэйэ',
		goPortal: 'Портаалга көһүү',
		house: 'Дьиэ',
		popular: 'Киэҥник биллэр',
		pupularServices: 'Киэҥник биллэр сервистэр',
		open: 'Арый',
		yes: 'Оннук ',
		no: 'Суох',
		share: 'Үллэһин',
		interesting: 'Интэриэһинэй',
		application: 'Сыһыарыылар',
		watch: 'Көр',
		link: 'Сигэ',
		linkURL: 'URL-сигэлэр',
		linkHeaderURL: 'Сирэйгэ/түһүмэххэ сигэ аата',
		linkHeader: 'Сигэ аата',
		locality: 'Нэһилиэнньэлээх пуун',
		pageChapter: 'сирэйгэ/түһүмэххэ',
		postcode: 'Индекс',
		textButton: 'Кунуопка тиэкиһэ',
		button: 'Кунуопка',
		date: 'Күнэ-дьыла',
		date0: 'Бэчээккэ тахсыбыт күнэ-дьыла ',
		updatedAt: 'Бүтэһик уларыйыы',
		createdAt: 'Тэрийии',
		attachFile: 'Файлы сыһыар ',
		description: 'Ойуулааһын',
		descriptionNecessarily: 'Ойуулааһын (булгуччу)',
		fullName: 'Араспаанньата Аата Аҕатын Аата',
		image: 'Ойуу',
		initiator: 'Көҕүлээччи',
		icon: 'Иконка',
		photo: 'Хаартыска',
		primarySourceSite: 'Төрүт саайт',
		linkPrimarySourceSite: 'Төрүт саайка киирэр сигэ',
		loading: 'Хачайдана турар...',
		main: 'Сүрүн ',
		read: 'Аах',
		readMore: 'Салгыы аах',
		registered: 'Регистрацияламмыт',
		received: 'Киирбит',
		receivedWith: 'Киирбит (күнтэн)',
		receivedBy: 'Киирбит (күҥҥэ диэри)',
		showOnMain: 'Сүрүн сирэйгэ көрдөр ',
		see: 'Көр',
		select: 'Тал',
		send: 'Ыыт',
		status: 'Статус',
		street: 'Уулусса',
		statistics: 'Статистика',
		size: 'Кээмэйэ',
		back: 'Кэннин диэки',
		title: 'Аата',
		theme: 'Тиэмэтэ',
		type: 'Тиибэ',
		types: 'Тииптэрэ',
		city: 'Куорат',
		cityCountyWeatherIndex: 'Куорат - Оройуон - Салгын ыстаансыйатын индексэ',
		header: 'Аата',
		headerNecessarily: 'Аата (булгуччу)',
		text: 'Тиэкис',
		position: 'Солото',
		fax: 'Факс',
		site: {
			title: 'Саайт',
			plural: 'Саайтар',
			isMain: 'Сүрүн саайт',
			isMain3: 'Үс сүрүҥҥэ ',
			allOrganizationSites: 'Тэрилтэ бары саайтыгар',
			creating: 'Саайтары оҥоруу',
			error: 'Саайты оҥорорго сыыһыы таҕыста',
		},
		appeals: {
			title: 'Туруорсуу',
			submitAppeal: 'Туруорсуута киллэр',
			numberOfRequest: 'Туруорсуу ахсаана',
			shortDescription: 'Туруорсуу кылгас ис хоһооно',
			showAppealsOnPanel: 'Панелга "Туруорсуулар" диэни көрдөр',
		},
		broadcast: {
			title: 'Трансляция',
			titles: 'Трансляция',
			dateStartBroadcast: 'Трансляция саҕаланыан иннинээҕи күн-дьыл',
			linkBroadcast: 'Трансляцияҕа сигэ',
			shortDescription: 'Трансляция кылгас ис хоһооно',
			showBroadcastOnPanel: 'Панелга "Трансляция" диэни көрдөр',
		},
		gisMap: {
			title: 'Гис-каарта',
			showMapOnPanel: 'Панелга "Гис-каарта" диэни көрдөр',
			mapOfRepublic: 'Өрөспүүбүлүкэ ГИС-каартата',
		},
		comment: {
			title: 'Быһааран биэрии',
			postTitle: 'Быһааран биэр',
			post: 'Ыыт',
			text: 'Быһааран биэрии тиэкиһэ',
			plural: 'Быһааран биэриилэр',
			confirmDelete: 'Быһааран биэриини сотторуллар дуо?',
			emptyAuthor: 'Ааккын киллэр',
			emptyText: 'Тиэкистэ киллэр (кырата 3 символ)',
		},
		widget: {
			title: 'Виджет',
			overviewPanel: 'Түмэн көрүү панела',
			quickAccessBar: 'Түргэнник киирии панела',
			systemWidget: 'Тиһик виджеттара',
			usersWidget: 'Туһанааччы виджеттара',
			userWidget: 'Туһанааччы виджета',
			showUserWidgetOnPanel: 'Панелга "Туһанаачы виджета" диэни көрдөр',
			iconUserWidget: 'Иконка',
			shortDescription: 'Кылгас ис хоһооно',
			imageForSample: 'Көстүү холобур быһыытынан',
			numberOfSitesOnPortal: 'Портаалга саайт ахсаана',
			sitesOnPortal: 'саайтар Портаалга',
			showSitesOnPanel: 'Панелга "Портаалга саайт ахсаана" диэни көрдөр',
			plural: 'Виджеттар',
			variant: 'Барыйаан',
			widget1: '1 барыйаан',
			widget2: '2 барыйаан',
			widget3: '3 барыйаан',
			widget4: '4 барыйаан',
			widget5: '5 барыйаан',
			selectWidgetVersion: 'Виджет версиятын тал',
			version: 'Версията',
			backgroundUnderWidget: 'Иһинээҕитэ үчүгэйдик көстөрүгэр анаан виджет кэннинээҕи көстүү (бекграунд)',
			warningOneWidget: 'Бу сурук көстөр, ол аата сүрүн сирэйгэ ханнык эрэ виджет номнуо көстөн турар (бииртэн элбэҕи талыллыбат)',
		},
		feedback: {
			post: 'Ыыт',
			emptyAuthor: 'Ааккын киллэр',
			emptyEmail: ' e-mail аадырыскын киллэр',
			emptyReason: 'Суруйар төрүөккүн тал',
			emptyTitle: 'Тиэмэтин киллэр (кырата үс бэлиэ баар буолуохтаах)',
			emptyText: 'Тиэкискин киллэр (кырата үс бэлиэ баар буолуохтаах)',
			plural: 'Хардата',
		},
		banner: {
			plural: 'Баннердар',
			title: 'Баннер',
			noImage: 'туох да көстүбэт',
			attention: 'Саайка баннер холбоммут буоллаҕына, бүтэһик холбоммут баннер эрэ көстөр',
		},
		wind: {
			title: 'Тыал',
			speedFactor: 'Түргэнэ',
			fadeOpacity: 'Шлейф уһуна',
			particleLife: 'Өлүүскэ олоҕо',
			opacity: 'Дьэҥкирэ',
		},
		weather: {
			title: 'Күн-дьыл туруга',
			temp: 'Тэмпэрэтиирэ',
			tempDescription: 'Сиртэн 2 м үрдүккэ тэмпэрэтиирэ кээмэйэ',
			tempMeasure: '°C',
			pressure: 'Баттааһын',
			pressureDescription: 'Салгын баттааһына',
			pressureMeasure: 'рт.ст. мм',
			precipitation: 'Сөҥүүлэр',
			precipitationDescription: '3 чаас устатыгар сөҥүү мунньуллуута',
			precipitationMeasure: 'кв. миэтэрэҕэ кг',
			humidity: 'Сииктээҕэ',
			humidityDescription: 'Сиртэн 2 м үрдүккэ салгын сиигэ',
			humidityMeasure: '%',
			pm25: 'PM2.5',
			pm25Description: 'Салгыҥҥа баар 2.5 мкм уонна онтон кыра диаметрдаах кытаанах уонна убаҕас эттиктэр ',
			pm25Measure: 'куб. миэтэрэҕэ мкг',
			pm10: 'PM10',
			pm10Description: 'Салгыҥҥа баар 10 мкм уонна онтон кыра диаметрдаах кытаанах уонна убаҕас эттиктэр',
			pm10Measure: 'куб. миэтэрэҕэ мкг',
			co: 'CO',
			coDescription: 'СО араҥатын ис хоһооно',
			coMeasure: 'куб. миэтэрэҕэ мкг',
			no: 'NO',
			noDescription: 'NO араҥатын ис хоһооно',
			noMeasure: 'куб. миэтэрэҕэ мкг',
			no2: 'NO2',
			no2Description: 'NO2 араҥатын ис хоһооно',
			no2Measure: 'куб. миэтэрэҕэ мкг',
			ozone: 'Озон',
			ozoneDescription: 'О3 араҥатын ис хоһооно',
			ozoneMeasure: 'DU',
			so2: 'SO2',
			so2Description: 'SO2 араҥатын ис хоһооно',
			so2Measure: 'куб. миэтэрэҕэ мкг',
			feeling: 'курдук',
		},
		silam: {
			title: 'Салгын киртийиитэ',
			on: 'Көрдөр',
		},
		sites: {
			news: 'Сонуннар',
			events: 'Буолбут түгэн',
			vacancy: 'Аһаҕас турар үлэ миэстэтэ',
			'question-answer': 'Ыйытыы-хоруй',
			map: 'ГИС-каарта',
			'all-sites': 'Саайтар бары',
			'support-measure': 'Өйөбүл дьаһаллар',
			'about-republic': 'Өрөспүүбүлүкэ туһунан',
			'open-data': 'Аһаҕас чахчылар',
			null: ' ',
			organization: 'Тэрилтэ',
			template: 'Халыып',
			documents: 'Докумуоннар',
			media: 'Медианы харайар сир',
			npa: 'НБА барыллара',
			discussions: 'Ыйытыктар',
			'citizens-appeals': 'Гражданнар туруорсуулара',
			managements: 'Салалта',
			structure: 'Тутул',
			phonebook: 'Төлөпүөн ыйынньыга',
		},
		email: {
			title: 'E-mail',
			hint: 'mail@example.com',
			field: 'Электроннай почта',
			input: 'E-mail киллэр',
			exist: 'Маннык E-mail номнуо баар',
			invalidEmailAddress: 'Электроннай почта аадырыһа сыыһа',
		},
		language: {
			title: 'Тыл',
			plural: 'Тыллар',
			isPublicActive: 'Порталга тылын туттар',
		},
		document: {
			title: 'Докумуон',
			plural: 'Докумуоннар',
			registry: 'Докумуоннар эридьиэстэрэ',
			acceptBody: 'Ылар уорган',
			found: 'Булуллубут докумуоннар',
			file: 'Докумуон файла',
			findDocuments: 'Докумуоннары бул',
			noFinds: 'Докумуон булуллубата',
			ligament: 'Докумуону кытта ситим',
			addLigament: 'Докумуону кытта ситимнээ',
			parentDocument: 'Үрдүкү турар докумуон',
			parentDocuments: 'Үрдүкү турар докумуоннар',
			childDocuments: 'Бас бэринээччилэр',
			ligamentAdd: 'Ситими эбэн биэр',
			noDocuments: 'Тоҕоостоох докумуон суох',
			signinAcceptApprovalAt: 'Илии баттаммыт/ылыллыбыт/бигэргэммит күнэ-дьыла',
			signinAcceptApprovalAtBefore: 'Илии баттаммыт/ылыллыбыт/бигэргэммит күнэ-дьыла саҕаламмыт күнэ',
			signinAcceptApprovalAtAfter: 'Илии баттаммыт/ылыллыбыт/бигэргэммит күнэ-дьыла түмүктэммит күнэ',
			effectiveStartAt: 'Күүһүгэр киирбит/дьайыыта саҕаламмыт күнэ-дьыла',
			expirationAt: 'Дьайыыта бүппүт күнэ-дьыла',
			warningLigament: 'БОЛҔОЙ: Аһаҕас өттүгэр докумуоннар ситимнэригэр "Бас бэринээччи докумуоннар" булуокка баар эрэ суруйуулар көстөллөр',
		},
		documentType: {
			title: 'Докумуон тиибэ',
			plural: 'Докумуоннар тииптэрэ',
		},
		documenttype: {
			title: 'Докумуон тиибэ',
		},
		documentSubject: {
			title: 'Докумуон тематиката',
			plural: 'Докумуоннар тематикалара',
		},
		documentLigamentType: {
			title: 'Ситим тиибэ',
			plural: 'Ситимнэр тииптэрэ',
		},
		organization: {
			importPhonebook: 'Тастан киллэр',
			phonebook: 'Төлөпүөн нүөмэрдэрин ыйынньыга',
			phonebookSize: 'Төлөпүөн нүөмэрдэрин ыйынньыгын кээмэйэ',
			phonebookFormsArrayFirst: 'суруйуу',
			phonebookFormsArraySecond: 'суруйуулар',
			phonebookFormsArrayThird: 'суруйуулары',
			official: 'Сололоох сирэй (гражданнар туруорсуулара)',
			rcitOrganization: 'Төлөпүөн нүөмэрдэрин ыйынньыгар аата-суола',
			mainInfo: 'Сүрүн иһитиннэрии',
			documents: 'Докумуоннар',
			contacts: 'Контактара',
			title: 'Тэрилтэ',
			plural: 'Тэрилтэлэр',
			name: 'Тэрилтэ аата',
			fullName: 'Тэрилтэ толору аата',
			shortName: 'Кылгас аата',
			ownershipForm: 'Бас билии көрүҥэ',
			address: 'Юридическай аадырыһа',
			inputAddressPlaceholder: 'Уулуссаҥ аатын, дьиэҥ нүөмэрин киллэр',
			inputFioPlaceholder: 'Араспаанньаҕын, ааккын, аҕаҥ аатын киллэр',
			inputPhonePlaceholder: 'Билсэр нүөмэри киллэр',
			headName: 'Салайааччы АААА',
			headPosition: 'Салайааччы солото',
			inn: 'ИНН',
			ogrn: 'ОГРН',
			kpp: 'КПП',
			comment: 'Быһааран биэрии',
			externalId: 'Тас ситимҥэ тэрилтэ ID',
			externalData: 'Тас ситимтэн тэрилтэ иһинээҕитэ',
			position: 'Соло',
			structuralDivision: 'Тутул салаата',
			description: 'Тэрилтэ туһунан иһитиннэрии',
			info: 'Сүрүн сибидиэнньэлэр',
			factAddress: 'Дьиҥ баар аадырыһа',
			secondaryInfo: 'Эбии сибидиэнньэлэр',
			headInfo: 'Салайааччы туһунан чахчылар',
			okato: 'ОКАТО',
			oktmo: 'ОКТМО',
			okved: 'ОКВЭД',
			okpo: 'ОКПО',
			okopf: 'ОКОПФ',
			okogu: 'ОКОГУ',
			okfs: 'ОКФС',
			rngi: 'РНГИ /эридьиэс нүөмэрэ',
			noStaff: 'Үлэһит булуллубата',
			noRequests: 'Сайаапка булуллубата',
			noBankAccounts: 'Баан счета булуллубата',
			contractor: 'Бэдэрээтчит',
			activityType: 'Үлэ көрүҥэ',
			group: 'Тэрилтэлэр бөлөхтөрө',
			contragentType: 'Контрагент көрүҥэ',
			type: 'Учуот эбийиэгин тиибэ',
			status: 'Тэрилтэ ыстаатыһа',
			postAddress: 'Почтаҕа ыйыллар аадырыс',
			linkTop: 'Үөһэ өттүгэр тахсарга сигэ',
			inputPlaceholder: 'Холобур: Управление',
			inputPositionPlaceholder: 'Холобур: Салайааччы',
			higherLevelOrganization: 'Үрдүкү турар тэрилтэ',
			additional: 'Эбии',
			structure: {
				style: 'Элэмиэннэри истиилинэн оҥоруу',
				background: 'Фон өҥө',
				colorText: 'Тиэкис өҥө',
				colorBranch: 'Салаалар өҥнөрө',
				apply: 'Тутун',
				imageStructure: 'Тутулу ойуулаан көрдөрүү',
				useImage: 'Ойууну туһан',
				structureDescription: 'Эбии  суруй',
				saveStructureDescription: 'Ойуулааһыны харай',
				defaultStyles: 'Эрдэ олохтоммут истиил',
				parentItem: 'Төрүт элэмиэн',
			},
			phonebookPriority: 'Должностька сортировка приоритета',
			phonebookOther: 'Атын',
		},
		topic: {
			title: 'Рубрика',
			plural: 'Рубрикалар',
		},
		ArticleAppurtenance: {
			title: 'Туохха сыһыаннааҕа',
			plural: 'Туохха сыһыаннааҕа',
		},
		history: {
			organizationCreate: 'тэрилтэни тэрийдэ',
			organizationUpdate: 'полялары уларытта',
			update: 'уларытта',
			to: 'туохха',
		},
		discussionsNPA: {
			title: 'Нуормалыыр быраап докумуоннара',
			discussionGoingOn: 'Дьүүллэһии бара турар',
			discussionExpiresSoon: 'Дьүүллэһии сотору бүтэр',
			discussionEnd: 'Дьүүллэһии түмүктэннэ',
			searchByDocument: 'Докумуонунан уонна нүөмэринэн көрдөөһүн',
			developmentEnd: 'Сүрүннүүр дьайыыны сыаналааһын үлэтэ түмүктэннэ',
			documentsFound: 'Булуллубут докумуоннар:',
			note: 'Хос быһаарыы',
			name: 'НБА аата',
			status: 'Ыстаатыһа',
			procedure: 'Процедурата',
			stage: 'Түһүмэҕэ',
			text: 'Ойуулааһын',
			department: 'Биэдэмистибэ',
			urlFiles: 'Сыһыарыллыбыт файлларга сигэ',
			urlResources: 'Дьүүллэһии ыытыллар сиригэр сигэ',
			type: 'Бырайыак көрүҥэ',
			address: 'Түмүгү почтанан ыытарга анаан аадырыс',
			contactPerson: 'Сибээстэһэр сирэй',
			plural: 'НБА барыла',
			formsArrayFirst: 'докумуон',
			formsArraySecond: 'докумуон',
			formsArrayThird: 'докумуоннар',
		},
		discussionsnpastatus: {
			title: 'Анал турук',
		},
		discussionsNPAProcedure: {
			stages: 'Кэрдиис',
		},
		discussions: {
			title: 'Ыйытык',
			titlePlural: 'Ыйытыктар',
			plural: 'Ыйытыктар',
			goToOther: 'Атын ыйытыктарга көһүү',
			formsArrayFirst: 'ыйытык',
			formsArraySecond: 'ыйытыктар',
			formsArrayThird: 'ыйытыктар',
		},
		guidelinesRegulations: {
			title: 'Салалта уонна регламент',
			manualsInstructions: 'Салалталар, ыйыылар',
			checklist: 'Хонтуруоллуур лиистэр',
			externalRegulations: 'Тас регламеннар',
			nameGuideline: 'Салалта аата',
			nameChecklist: 'Хонтуруоллуур лиис аата',
			nameRegulation: 'Регламент аата',
			checklistChapter: 'Түһүмэхтэр хонтуруоллуур лиистэрэ',
			addressUrl: 'URL аадырыһа',
		},
		LOGIN_FAILED: 'Сөбө суох логин/пароль',
		LOGIN_WAIT: 'Холонуу лимиитин куоһарда',
		LOGIN_EMPTY_CAPTCHA: 'Куода киирбэтэ',
		LOGIN_INVALID_CAPTCHA: 'Сөбө суох куод',
		captcha: 'Хартыынаҕа баар куод',
		checkCaptcha: 'Капчаны бэрэбиэркэлээ',
		inputCaptcha: 'Капчаны киллэр',
		wait: 'Тохтоо',
		seconds: 'сөкүүндэ',
		noImage: 'Хаартыска суох',
		linksFeed: {
			plural: 'Сигэ лиэнтэтэ',
		},
		linksfeedcategory: {
			title: 'Категория',
		},
		cookie: {
			buttonText: 'Өйдөнөр',
			additionalTextFirst:
				'Биһиги cookie файллары контент чопчу киһиэхэ туһаайылларыгар, туһанааччыга көмпүүтэр тиһигэр тустаах көҥүлү, быраабы биэрэргэ уонна трафигы ырытарга анаан туттабыт. Сookie файллары араарарга веб-браузер настройкатыгар киирэҕин. Ол эрээри маннык дьайыы портаалы кытта үлэни хааччахтыан сөп.',
			secondTextSecond:
				'Интэриниэт бу ресурсатынан туһанан, бэйэтин көҥүл баҕатынан уонна бэйэтин туһатыгар туһанааччы автоматизация көмөтүнэн, ону тэҥэ автоматизация ньыматын туһаныыта суох, оҥорууга, ол иһигэр бэйэтин тус чахчыларын, киирээччи туһунан чахчылары ( чопчулаан эттэххэ, IP-аадырыс, барыллаан ханан баара, браузер версията, дисплейин пиксэлинэн кээмэйэ, операционнай тиһигин уонна көмө бырагырааманан хааччыллыытын версията, тэрил модела, ресурсата, көрдүүр тиһиктэр, сайтан көһөргө туттуллубут этиилэр, баннердар, көрбүт сирэйдэрэ уонна саайтка киирэн атаарбыт кэмэ) биэриигэ (ол иһигэр киирээччилэри ырытар туора сервистэргэ Спутник.Аналитика, Яндекс.Метрика, vk.com, ok.ru) уонна оҥорууга, чопчулаан эттэххэ - "Тус чахчылар тустарынан" 152-ФС көрүллүбүт дьайыылары оҥорууга сөбүлэҥин биэрэр. Өскөтүн киирээччи интэриниэт-ресурса киирээччи туһунан дааннайдары автоматизация көмөтүнэн оҥорорун кытта сөбүлэспэт буоллаҕына, кини бэйэтин браузерын онно сөп түбэһиннэрэн настройкалыан эбэтэр саайтан тахсыан сөп.',
			linkText: 'cookie файллар',
		},
		article: {
			priority: 'Таһаарыыга бастатыы',
			notFound: 'Сонун булуллубата',
		},
		subMenu: {
			more: 'Өссө',
			hide: 'Кистээ',
		},
		module: 'Модуль',
		pageToolbar: {
			requiredPages: 'Булгуччулааах сирэйдэр',
			expandPages: 'Барытын ас',
		},
		templateToolbar: {
			updateSites: 'Саайтарга саҥатытан биэр',
			sites: 'Саайтар',
			selectedCountSites: 'Талылынна:  {{countSites}}',
			successMessage: 'Саайтар саҥатытылыннылар',
			error: 'Сыыһыы таҕыста',
		},
		selectAll: 'Барытын тал',
		file: {
			moveOrSelectFile: 'Көһөр эбэтэр файлы тал',
		},
		checklist: {
			number: '№',
			createByMenu: 'Хонтуруоллуур лииһи оҥорон таһаар',
			error: 'Хонтуруоллуур лииһи саҥатытыыга сыыһыы таҕыста',
			successCreate: 'Хонтуруоллуур лиис саҥатытылынна',
			dataSection: 'Сибидиэнньэлэр бастара',
			dataSubsection: 'Сибидиэнньэлэр хос бастара',
			data: 'Сибидиэнньэлэр',
			dataType: 'Сибидиэнньэлэр көрүҥнэрэ',
			publishPeriods: 'Бэчээккэ таһаарыы кэмэ-кэрдиитэ',
			controls: 'Хонтуруол сириэстибэлэрэ',
			responsibleSpecialists: 'Эппиэттээх исписэлиистэринэн сибидиэнньэлэр',
			variableLegalBasis: 'Нуормалыыр быраабынан олохтооһун',
			link: 'Сигэ',
			createdAt: 'Пууну киллэрии дьыла-күнэ',
			errorUpdateSites: 'Саайтар чеклиистэрин саҥатытыыга сыыһыы',
			successUpdateSites: 'Саайтар ситиһиилээхтик саҥатытылыннылар',
			isRequirePage: 'Булгуччулаах сирэй',
			nextDateUpdate: 'Аныгыскы саҥатытыы күүтүллэр күнэ-дьыла',
			textPublishPeriods: 'Саҥатытыы эргиллэр кэмин тиэкиһэ',
			nextCheckDate: 'Аныгыскы бэрэбиэркэ күнэ-дьыла',
			updateFrequency: 'Саҥатытыы эргиллэр кэмэ',
		},
		export: 'Таска таһаарыы',
		reportingYear: 'Отчуоттанар сыл',
		currentYear: 'Туһааннаах сыл',
		nextReportingYear: 'Отчуоттанар сыл кэнниттэн кэлэр',
		lastYear: 'Ааспыт сыл',
		documentExists: 'Маннык тииптээх, ылынар уорганнаах, илии баттаммыт күннээх уонна нүөмэрдээх докумуон номнуо баар.',
		topicButtonGroup: {
			maxCount: 'Үлэлиир кунуопка муҥутуур ахсааннаах',
			maxCountError: 'Үлэлиир тематическай кунуопка муҥутуур ахсаана куоһарылынна',
			errorEmpty: 'Кунуопкалар бөлөхтөрө булуллубата',
			siteTemplate: 'Саайт халыыба',
			original: 'Кунуопкалар ураты бөлөхтөрө',
			topicButtons: 'Тематическай кунуопкалар',
		},
		topicButton: {
			title: 'Тематическай кунуопка',
			plural: 'Тематическай кунуопкалар',
			label: 'Кунуопка тиэкиһэ',
			link: 'Сигэ',
			colorText: 'Тиэкис өҥө',
			colorBackground: 'Фон өҥө',
			isActive: 'Сүрүн сирэйгэ',
			notFound: 'Тематическай кунуопка оҥоһуллубатах',
			preview: 'Кунуопка көрүҥэ',
			order: 'Бэрээдэк',
			invalidLink: ' URL кээмэйэ сыыһа',
			updateError: 'Сыыһыы таҕыста. Сүрүннээччигэ эт',
			labelMaxLength: 'Бэлиэлэр муҥутуур ахсааннара {{maxLength}}',
		},
		label: {
			title: 'Тег',
			plural: 'Тег',
		},
		topicCard: {
			title: 'Рубрика карточката',
			plural: 'Рубрика карточкалара',
			isActive: 'Көрдөр',
			priority: 'Таһаарыы бэрээдэгэ',
			organizations: 'Рубрика тэрилтэлэргэ тоҕоостоох',
		},
		recordSelect: {
			selectCount: 'Талылынна: {{countRecords}}',
		},
		noRecord: 'Суруллубут булуллубата, эбэтэр ону көрөр Эйиэхэ бобуулаах',
		verificationCode: 'Бэрэбиэркэлиир код',
		confirm: 'Бигэргэт',
		sendedVerificationCode: 'Бэрэбиэркэлиир код ыйыллыбыт email аадырыска ыытылынна',
		invalidVerificationCode: 'Бэрэбиэркэлиир код сыыһа',
		esiaLogin: 'Полялары автоматически толорорго ЕСИА көмөтүнэн киир',
		logout: 'Таҕыс',
		esiaUser: 'Эн  {{userFIO}} быһыытынан киирдиҥ',
		siteTemplate: {
			mainMenuLimit: '1 таһымнаах сүрүн меню пууннарын муҥутуур ахсаана',
			mainMenuLimitError: 'Сүрүн менюга көстөр үлэлиир түһүмэхтэр муҥутуур ахсааннара куоһарылынна',
		},
		pageDevelopment: 'Сирэй оҥоһулла сылдьар',
		writeAction: 'Суруй',
		alt: {
			emptyImage: 'Бүөлүүр ойуу',
			like: 'Сөбүлээтим',
			dislike: 'Сөбүлээбэтим',
			iconDollar: 'Доллар бэлиэтэ',
			iconEuro: 'Евро бэлиэтэ',
			arrowLeft: 'Хаҥас диэки ыйар стрелка',
			arrowRight: 'Уҥа диэки ыйар стрелка',
			playOrPause: 'Холбоо/тохтот',
			playerPrev: 'Инники суруллубут',
			playerRewind: 'Төттөрү эрийии',
			playerNext: 'Аныгыскы суруйуу',
			telegram: 'Телеграмм бэлиэтэ',
			vk: 'Вконтакте бэлиэтэ',
			twitter: 'Twitter бэлиэтэ',
			rutube: 'RuTube бэлиэтэ',
			odnoklassniki: 'Одноклассники бэлиэтэ',
			rss: 'RSS бэлиэтэ',
			GISMap: 'Өрөспүүбүлүкэ ГИС-каартата',
			republicNews: 'Өрөспүүбүлүкэ суолталаах сонуннара барыта',
		},
		goTo: 'Көс',
		imageOnMain: 'Сүрүн сирэйгэ ойуу',
		openDataFormat: {
			name: 'Аат',
			code: 'Куод',
			title: 'Аһаҕас чахчы кээмэйэ',
			plural: 'Аһаҕас чахчылар кээмэйдэрэ',
		},
		enterCustomVariant: 'Хоруйуҥ барыйаанын ый',
		phoneNumber: 'Төлөпүөн нүөмэрэ',
		reasonFeedback: 'Туруорсуу төрүөтэ',
		themeFeedback: 'Туруорсуу тиэмэтэ',
		messageFeedback: 'Туруорсуу тиэкиһэ',
		activeMenuItem: '1 таһымнаах сүрүн меню көхтөөх пууннарын ахсаана',
		npaLink: {
			title: 'НБА архыыбыгар сигэ',
			plural: 'НБА архыыбыгар сигэлэр',
			text: 'Кунуопка тиэкиһэ',
			link: 'Сигэ',
			exists: 'Сигэ номнуо баар',
			maxLengthText: 'Устуруока муҥутуур уһуна  {{strLength}}',
			invalidLink: 'Сигэ кээмэйэ сыыһа',
			isActive: 'Үлэлиир',
		},
		notModalAccess: 'Киирэр быраап суох',
	},
};
